import React, { useState, useEffect, useRef } from "react";
import "../../../assets/css/topbar.css";
import teamlogo from "../../../assets/img/teamlogo.png";
import Appleauthorised1 from "../../../assets/img/Appleauthorised1.png";
import Appleauthorised2 from "../../../assets/img/Appleauthorised2.png";
import CardItem from "../../../components/common/Card-Item/Card-Item";
import { FaBalanceScale, FaEnvelope } from "react-icons/fa";
import { FaPhoneVolume } from "react-icons/fa";
import { FaShoppingBag, FaTimes, FaSignOutAlt } from "react-icons/fa";
import { FaBars } from "react-icons/fa";
import { FaUser, FaSearch, FaHeart } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { checkSessionValidity, getSampleCurrencyFormat } from "../../../utils/utils";
import { AiOutlineCaretDown } from "react-icons/ai";
import { SEARCH, WISHLIST_COUNT, GETWISHLIST_V2, CATEGORIES, CATEGORIES_DATA_NAME } from "../../../assets/graphql";
import { apiHandler } from "../../../api";
import { endpoint } from "../../../api/endpoint";
import { toast } from "react-toastify";
import { saveBanner, saveCatagory, saveLogo, savewishlist } from "../../../features/HomePageSlice/homeDataSlice";

import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { BsBorderLeft } from "react-icons/bs";

const Header = () => {
  const [showImg, setShowImg] = useState(localStorage.getItem("loginURL") === "hpcl" ? false : true);
  const [leftMenuState, setLeftMenuState] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [searchList, setSearchList] = useState([""]);
  const [mainCategory, setMainCategory] = useState("");
  const leftAboutMenu = useRef();
  const rightContent = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getURL = localStorage.getItem('loginURL');

    // Get the entire URL
  const fullURL = `#/${getURL}`;

  const [show, setShow] = useState(false);
  const [showsearchmodal, setShowSearchModal] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const wrapperRef = useRef(null);
  const CartRef = useRef(null);

  const [isScrollValueMoreThanHeaderHeight, setIsScrollValueMoreThanHeaderHeight] = useState(false);
  
  const {
    addtoproductcart,
    storeconfig,
    wishlist,
    compareData,
    companyLogo,
    landingData,
    categories,
  } = useSelector((state) => state.home); 
  
  useEffect(() => {
    const search = async (obj) => {
      const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: { search: searchParam },
          query: SEARCH,
        },
      });

      const dataArray = landingData ? landingData?.categoriesProduct[0].selectedId.split(',') : [];
    
      const filteredArray = result.data.products.items.filter((value) => dataArray.includes(value.categories[0]?.id.toString()));
     
      // landingData?.categoriesProduct[0]
      checkSessionValidity(result.data, dispatch);
      setSearchList(filteredArray);
    };
    search(searchParam);
  }, [searchParam, landingData]);

  useEffect(() => {
    // getHeaderCategores(landingData?.categoriesProduct[0].headerCat);
    const handleScroll = () => {
      setIsScrollValueMoreThanHeaderHeight(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSearch(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    const currentUrl = window.location.href;
    const parts = currentUrl.split("/");
    const value = parts[parts.length - 1];
    const accessURL = localStorage.getItem("loginURL");
  })
  useEffect(() => {
    function handleClickOutside(event) {
      if (CartRef.current && !CartRef.current.contains(event.target)) {
        let elems = document.getElementById("cartDropdown");
        if (elems) {
          elems.setAttribute("aria-expanded", "false");
          elems.classList.remove("show");
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [CartRef]);

  const { token, userData } = useSelector((state) => state.login);

  const logoutBtn = () => {
      dispatch({ type: "SIGNOUT" });
      const url = localStorage.getItem("loginURL");
      localStorage.clear();
      // console.log(url)
      navigate(`/${url}`);
      window.location.reload()
  }

  // const logout = () => {
  //   // dispatch({ type: "SIGNOUT" });
  //   const url = localStorage.getItem("loginURL");
  //   console.log(url)
  //   // localStorage.clear();
  //   // localStorage.setItem("loginCheck", false);
  //   // navigate(`/${url}`);
  // };

  const searchResult = () => {
    setShowSearch(false);
    setSearchParam("");
    navigate("/search?q=" + searchParam);
  };

  const setsearchvalues = (e) => {
    setSearchParam(e.target.value);
    setShowSearchModal(true);
  };

  const getWishlist = async () => {
    if (token) {
      const wishlistCount = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        authToken: token,
        data: {
          base_url: endpoint.API_BASE_URL,
          variables: {},
          query: WISHLIST_COUNT,
        },
      });
      checkSessionValidity(wishlistCount.data, dispatch);
      if (wishlistCount.data.wishlist) {
        if (wishlistCount.data.wishlist.items_count > 0) {
          // setLoader(true);
          const wishlistresult = await apiHandler({
            url: endpoint.GRAPHQL_URL,
            method: "POST",
            authToken: token,
            data: {
              base_url: endpoint.API_BASE_URL,
              variables: {},
              query: GETWISHLIST_V2,
            },
          });
          checkSessionValidity(wishlistresult.data, dispatch);
          if (
            !wishlistresult.data.error_code &&
            wishlistresult.data.customer &&
            wishlistresult.data.customer.wishlist_v2
          ) {
            dispatch(savewishlist(wishlistresult.data.customer.wishlist_v2));
          }
        }
      }
    }
  };

  useEffect(() => {
    getWishlist();
    const handleScroll = () => {
      const position = window.pageYOffset;

      if (position > 36) {
        setLeftMenuState("fixed-top");
      } else {
        setLeftMenuState("navbar");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const getTotalAmount = () => {
    let totalPrice = 0;
    addtoproductcart &&
      addtoproductcart.forEach((cartitem) => {
        if (cartitem && cartitem.prices && cartitem.prices.price && cartitem.prices.price.value) {
          totalPrice = totalPrice + cartitem.quantity * cartitem.prices.price.value;
        }
      });
    return addtoproductcart[0] ? getSampleCurrencyFormat("INR", totalPrice) : "0.00";
  };
  const getTotalCartItem = () => {
    let count = 0;
    addtoproductcart &&
      addtoproductcart.forEach((cartitem, index) => {
        count = cartitem ? count + cartitem.quantity : null;
      });
    return count;
  };
  const getWishListItemItem = () => {
    let count = 0;
    count = wishlist.items_count;
    return count;
  };
  const getTotalCompareItem = () => {
    let count = 0;
    count = compareData.item_count ? compareData.item_count : 0;

    return count;
  };

  const handleKeypress = (e) => {
    //it triggers by pressing the enter key

    if (e.keyCode === 13) {
      searchResult();
    }
  };
  const authenticate = () => {
    if (!token) {
      toast.error("Please Login");
    }
  };
  useEffect(() => {
    const handleHiddenBsCollapse = () => {
      let elems = document.getElementById("cartDropdown");
      if (elems) {
        elems.setAttribute("aria-expanded", "false");
        elems.classList.remove("show");
      }
    };
    let elements = document.getElementById("navDropdown");
    elements.addEventListener("hidden.bs.collapse", handleHiddenBsCollapse);
    return () => {
      elements.removeEventListener("hidden.bs.collapse", handleHiddenBsCollapse);
    };
  }, []);
  useEffect(() => {
    // runs on location, i.e. route, change

    let elems = document.getElementById("cartDropdown");
    if (elems) {
      elems.setAttribute("aria-expanded", "false");
      elems.classList.remove("show");
    }
  }, [location]);

  const onCartIconClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // mark these as open
    let elems = document.getElementById("cartDropdown");
    if (elems) {
      if (elems.getAttribute("aria-expanded") === "true") {
        elems.setAttribute("aria-expanded", "false");
      } else {
        elems.setAttribute("aria-expanded", "true");
      }

      if (elems.classList.contains("show")) {
        elems.classList.remove("show");
      } else {
        elems.classList.add("show");
      }
    }
  };
  const errorCheckout = () => {
    let inactiveProduct = false;
    addtoproductcart &&
      addtoproductcart.forEach((cartitem) => {
        if (
          cartitem &&
          cartitem.errors &&
          cartitem.errors[0] &&
          cartitem.errors[0].code &&
          cartitem.errors[0].code === "ITEM_QTY"
        ) {
          inactiveProduct = true;
        }
      });
    if (inactiveProduct) {
      toast.error("please remove invalid item");
    } else {
      navigate("/checkout");
    }
  };

  const getHeaderCategores = async (selectedCategories) => {
    const resultArray = selectedCategories.split(",");
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { resultArray },
        query: CATEGORIES_DATA_NAME,
      },
    });
    if (!result.data.error_code) {
      dispatch(saveCatagory(result.data.categories.items));
      setMainCategory(result.data.categories.items);
      // dispatch(dispatch(saveBanner(result.data.prelogin.banners)));
      // if(value === "default") {
      //   dispatch(saveLogo(""));
      // } else {
      //   dispatch(saveLogo(result.data.prelogin.company[0].logo));
      // }
      // dispatch(saveAccessories(result.data.products.items));
    }
  };
console.log(landingData)
  return (
    <>
      <header className="header header-absolute ">
        {/* <!-- Top Bar--> */}
        <div className="top-bar">
          <div className="container">
            <div className="row d-flex align-items-center">
              <div className="col-sm-5 d-none d-lg-block">
                <ul className="list-inline topbar-text mb-0">
                  <li className="list-inline-item pe-3 me-0 ">
                    <i>
                      <FaEnvelope />{" "}
                    </i>
                    <a className="parent-header-link-style" href={"mailto:" + (landingData.company[0].email ? landingData.company[0].email : storeconfig.support_email)}>
                      {landingData.company[0].email ? landingData.company[0].email : storeconfig.support_email}
                    </a>
                  </li>
                  <li className="list-inline-item px-3 border-start d-none d-lg-inline-block">
                    <i>
                      {" "}
                      <FaPhoneVolume />
                    </i>
                    <a className="parent-header-link-style" href={"tel:" + (landingData.company[0].mobile ? landingData.company[0].mobile : storeconfig.support_phone)}>
                      {landingData.company[0].mobile ? landingData.company[0].mobile : storeconfig.support_phone}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 cashbacktext">
                
                {landingData.company[0].header_text ? landingData.company[0].header_text : ""}
                
              </div>
              <div className="col-sm-2 d-none d-lg-block d-flex justify-content-end userlogin">
                {token && token !== "" ? (
                  <>
                    <div class="dropdown">
                      <div>
                        <a style={{ marginRight: "10px", cursor: "pointer" }}>
                          Hi,
                          {userData.firstname ? userData.firstname.slice(0, 15) : <>Customer</>}
                          <span className="dropdownicon">
                            <AiOutlineCaretDown />
                          </span>
                        </a>
                      </div>
                      <div class="dropdown-content" id="navbarCollapse">
                        <a href="/#/dashboard"> My Account</a>
                        <a href="/#/account-information"> Edit Profile</a>
                        <a href="/#/order-listing"> Order</a>
                      </div>
                    </div>
                    <button onClick={() => logoutBtn()}>
                      Logout
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Top Bar End--> */}
        {/* Navbar */}
        <nav
          ref={leftAboutMenu}
          className={
            leftMenuState === "fixed-top"
              ? "navbar navbar-expand-lg navbar-sticky navbar-airy navbar-dark bg-fixed-white navbar-hover-light navbar-fixed-light fixed-top"
              : "navbar navbar-expand-lg navbar-sticky navbar-airy navbar-dark bg-fixed-white navbar-hover-light navbar-fixed-light "
          }
        >
          <div className="container">
            <div className="responsive-menu d-lg-none">
              <Button variant="primary" onClick={handleShow} className="d-lg-none">
                <FaBars />
              </Button>
            </div>
            <div className="navbar-brand d-flex align-items-center justify-content-center">
              
              {companyLogo ? (
                <>
                  
                  <a href={fullURL}>
                    <img style={{ width: "100px" }} src={companyLogo} alt="Company Logo" />
                  </a>
                  <div
                    style={{
                      borderRight: "1px solid #000" /* Add a vertical line using a border */,
                      height: "30px" /* Adjust the height of the line as needed */,
                      margin: "0 10px" /* Add margin to separate the images */,
                    }}
                  ></div>
                </>
              ) : (
                ""
              )}
              <a href={fullURL}>
                <img src={teamlogo} alt="Team Computers Logo" />
              </a>
              {showImg &&
              <div className="applepartner">
                <img src={Appleauthorised1} alt="Team Computers Logo" />
                <img src={Appleauthorised2} alt="Team Computers Logo" />
              </div>}
            </div>

            <div className="d-none d-lg-block navmainmenu">
              <ul className="navbar-nav mx-auto">
                {categories &&
                  categories.map((category, index) => (
                    <li key={index} className="nav-item" onClick={() => authenticate()}>
                      <a
                        className="nav-link"
                        href={
                          category.display_subcategory === 1
                            ? "/#/category-list/" + category.url_key
                            : "/#/product-list/" + category.url_key
                        }
                      >
                        {category.name}
                      </a>
                    </li>
                  ))}
              </ul>
            </div>
            <div className="navright">
              <div className="nav-item navbar-icon-link" data-bs-toggle="search" onClick={() => authenticate()}>
                {token && token !== "" ? <FaSearch onClick={() => setShowSearch(!showSearch)} /> : <></>}
              </div>
              <div className="nav-item" onClick={() => authenticate()}>
                <a className="navbar-icon-link" href="/#/wish-list">
                  {token && token !== "" ? <FaHeart /> : <></>}
                </a>
              </div>
              <div className="nav-item d-none d-lg-block" onClick={() => authenticate()}>
                <a className="navbar-icon-link" href="/#/compare/">
                  {token && token !== "" ? <FaBalanceScale style={{ fontSize: "1.5rem" }} /> : <></>}
                </a>
              </div>
              <div id="navDropdown" className="nav-item dropdown display-none-bag">
                <a className="navbar-icon-link d-lg-none" href="/#/my-cart">
                  <span className="text-sm ms-2 ms-lg-0 text-uppercase text-sm fw-bold d-none d-lg-none">
                    View cart
                  </span>
                </a>
                {token && token !== "" ? (
                  <div>
                    <a
                      className="navbar-icon-link "
                      id="cartdetails"
                      href="javascript:void(0)"
                      onClick={(e) => onCartIconClick(e)}
                      data-bs-target="#"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <FaShoppingBag onClick={() => authenticate()} />
                      <div className="navbar-icon-link-badge">{getTotalCartItem()} </div>
                    </a>

                    <div
                      id="cartDropdown"
                      className="dropdown-menu dropdown-menu-animated dropdown-menu-end p-4"
                      aria-labelledby=""
                      ref={CartRef}
                    >
                      <div className="navbar-cart-product-wrapper">
                        {/* <!-- cart item--> */}
                        <FaTimes onClick={onCartIconClick} style={{ cursor: "pointer" }} />
                        {addtoproductcart &&
                          addtoproductcart.map((cartitem, index) =>
                            cartitem ? (
                              <div>
                                <CardItem
                                  key={index}
                                  ids={cartitem.id}
                                  airPods={
                                    cartitem.configured_variant &&
                                    cartitem.configured_variant.image &&
                                    cartitem.configured_variant.image.url
                                      ? cartitem.configured_variant.image.url
                                      : cartitem.product.image && cartitem.product.image.url
                                      ? cartitem.product.image.url
                                      : ""
                                  }
                                  AirPodsTitle={cartitem.product.name}
                                  uid={cartitem.uid}
                                  Quantity={cartitem.quantity}
                                  configurable_options={cartitem.configurable_options}
                                  Payment={getSampleCurrencyFormat(
                                    "INR",
                                    cartitem.prices && cartitem.prices.price && cartitem.prices.price.value
                                      ? cartitem.prices.price.value
                                      : 0
                                  )}
                                />
                              </div>
                            ) : null
                          )}
                      </div>
                      {/* <!-- total price--> */}

                      <div className="navbar-cart-total">
                        <span className="text-uppercase text-muted">Total</span>
                        <strong className="text-uppercase">{getTotalAmount()}</strong>
                      </div>
                      {/* <!-- buttons--> */}
                      <div className="cartbuttons">
                        <a className="btn btn-link text-dark me-3" href="/#/my-cart">
                          View Cart
                        </a>
                        {addtoproductcart.length ? (
                          <button className="btn default_button" onClick={() => errorCheckout()}>
                            Checkout
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>

          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                <img src={teamlogo} alt="Team Computers Logo" />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <ul className="navbar-nav mx-auto d-block">
                {categories &&
                  categories.map((category, index) => (
                    <li key={index} className="nav-item" onClick={() => authenticate()}>
                      <a
                        className="nav-link"
                        href={
                          category.display_subcategory === 1
                            ? "/#/category-list/" + category.url_key
                            : "/#/product-list/" + category.url_key
                        }
                        onClick={handleClose}
                      >
                        {category.name}
                      </a>
                    </li>
                  ))}

                <li className="nav-item" onClick={() => authenticate()}>
                  <a className="nav-link" href="/#/compare/" onClick={handleClose}>
                    <FaBalanceScale style={{ fontSize: "1.2rem" }} /> Compare
                  </a>
                </li>

                <li className="nav-item ">
                  {token && token !== "" ? (
                    <>
                 
                      <a href="" onClick={() => logoutBtn()} className="nav-link">
                        <i onClick={handleClose}>
                          <FaSignOutAlt />{" "}
                        </i>{" "}
                        &nbsp;Logout
                      </a>

                      <div class="dropdown" style={{ width: "100%" }}>
                        <span className="nav-link">
                          Hi,
                          {userData.firstname ? userData.firstname.slice(0, 15) : <>Customer</>}
                          <span className="dropdownicon">
                            <AiOutlineCaretDown />
                          </span>
                        </span>
                        <div class="dropdown-content" id="navbarCollapse">
                          <a href="/#/dashboard" onClick={handleClose}>
                            My Account
                          </a>
                          <a href="/#/account-information" onClick={handleClose}>
                            Edit Profile
                          </a>
                          <a href="/#/order-listing" onClick={handleClose}>
                            Order
                          </a>
                        </div>
                      </div>
                    </>
                  ) : (
                    <a href="/#/login" className="nav-link">
                      <div onClick={handleClose}>
                        <i>
                          <FaUser />
                        </i>
                        &nbsp; Login
                      </div>
                    </a>
                  )}
                </li>
              </ul>
            </Offcanvas.Body>
          </Offcanvas>
        </nav>
        {/* Navbar */}
        {/* <!-- Search Modal--> */}
        {showSearch && (
          <div className={isScrollValueMoreThanHeaderHeight ? "onscrolltop skscroll" : "skscroll"} ref={wrapperRef}>
            <div className="search-area">
              <div className="close-btn" onClick={() => setShowSearch(false)}>
                <FaTimes />
              </div>
              <div className="search-area-form">
                <div className="searchbartop">
                  <input
                    className="search-area-input"
                    onKeyDown={(e) => handleKeypress(e)}
                    value={searchParam}
                    onChange={(e) => setSearchParam(e.target.value)}
                    onBlur={() => setShowSearchModal(false)}
                    name="search"
                    id="search"
                    placeholder="What are you looking for?"
                  />
                  <button className="search-area-button" onClick={() => searchResult()}>
                    <FaSearch />
                  </button>
                </div>
                <div className="searchlistingbutton">
                  <ul>
                    {searchList.length > 0 ?
                      searchList.map((item) => (
                        <li>
                          <a href={"/#/product-detail/" + item.sku} onClick={() => setShowSearch(false)}>
                            <div className="searchmodalimg">
                              <img src={item.image.url} alt={item.name} />
                            </div>
                            <span>{item.name}</span>
                          </a>
                        </li>
                      )) :
                        <li className="no-product-found">
                            <span>No Product Found</span>
                        </li>
                      }
                  </ul>
                  {searchList.length > 0 ?
                    <div className="BottomMoreButton">
                      <button className="btn default_button" onClick={() => searchResult()}>
                        More Items
                      </button>
                    </div> : ""}
                </div>
              </div>
            </div>
          </div>
        )}
        {/* <!-- Search --> */}
      </header>
    </>
  );
};
export default Header;
